// For Webpack, we expose env vars via DefinePlugin in webpack.config.js
// The values are injected at build time from environment variables.
declare const __SUPABASE_URL__: string;
declare const __SUPABASE_PUBLISHABLE_KEY__: string;
declare const __VAPID_PUBLIC_KEY__: string;

export const SUPABASE_URL = __SUPABASE_URL__;
export const SUPABASE_PUBLISHABLE_KEY = __SUPABASE_PUBLISHABLE_KEY__;
export const VAPID_PUBLIC_KEY = __VAPID_PUBLIC_KEY__;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing Supabase config. Ensure webpack.config.js has DefinePlugin configured for __SUPABASE_URL__ and __SUPABASE_PUBLISHABLE_KEY__',
  );
}
